import { setUnlockDepotModalOpen } from "../../../reducers/ownApp";
import { useDispatch, useSelector } from "react-redux";

import { Modal } from "../Modal";
import { UnlockDepotModalActions } from "./UnlockDepotModalActions";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { unlockDepotModalOpenSelector } from "../../../reducers/ownApp/selectors";
import { unlockDepot } from "../../../reducers/depot/thunkActions";
import { depotLockSelector } from "../../../reducers/depot/selectors";
import { fetchDepotRouteMatrix } from "../../../reducers/matrixProfile/thunkActions";
import {
  getMatrixProfileType,
  getSelectedMatrixProfile,
} from "../../../reducers/matrixProfile/selectors";

const useStyles = makeStyles({
  text: {
    fontSize: "16px",
    lineHeight: "20px",
    marginTop: "10px",
  },
});

const UnlockDepotModal = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const unlockModalOpen = useSelector(unlockDepotModalOpenSelector);
  const depotLock = useSelector(depotLockSelector);
  const planType = useSelector(getMatrixProfileType);
  const profile = useSelector(getSelectedMatrixProfile);

  const closeClick = () => {
    dispatch(setUnlockDepotModalOpen(false));
  };

  const continueCLick = async () => {
    dispatch(setUnlockDepotModalOpen(false));
    await dispatch(unlockDepot(true));
    if (planType && profile)
      await dispatch(fetchDepotRouteMatrix({ type: planType, profile }));
  };

  return (
    <>
      <Modal
        maxWidth={"xs"}
        open={unlockModalOpen}
        onClose={closeClick}
        title={"Unlock Depot"}
        content={
          <>
            <Typography className={classes.text}>
              Are you sure you wish to unlock this depot map?{" "}
            </Typography>
            <Typography className={classes.text}>
              {depotLock.lockedByUserName} has made changes to some postcodes
              and will lose these changes if you continue.
            </Typography>
          </>
        }
        actions={
          <UnlockDepotModalActions
            onCancel={closeClick}
            onContinue={continueCLick}
          />
        }
        minWidth={500}
      />
    </>
  );
};

export default UnlockDepotModal;
